import { YES, NO } from "../store/businesslogic/hardwiredlogic";
import * as theme from "../theme";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import BugReportSimpleQuestion from "./BugReportSimpleQuestion";

// Adapted from YesNo.jsx

const BugReportYesNo = ({ text, onInput, fieldId, value }) => {
  return (
    <BugReportSimpleQuestion
      leftString={text}
      rightComponent={
        <YesNoRadio
          onInput={onInput}
          fieldId={fieldId}
          value={value}
        ></YesNoRadio>
      }
    ></BugReportSimpleQuestion>
  );
};

export const YesNoRadio = ({ onInput, fieldId, value }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        paddingTop: "1vmin",
      }}
    >
      <FormControl>
        <RadioGroup row key={"radioInput" + fieldId} onChange={onInput}>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <FormControlLabel
            value={YES}
            control={
              <Radio
                color="default"
                name="rd1"
                tabIndex={-1}
                checked={value === "Yes"}
              />
            }
            label={<YesNoTextOnly text={YES}></YesNoTextOnly>}
            tabIndex={0}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <FormControlLabel
            value={NO}
            control={
              <Radio
                color="default"
                name="rd2"
                tabIndex={-1}
                checked={value === "No"}
              />
            }
            label={<YesNoTextOnly text={NO}></YesNoTextOnly>}
            tabIndex={0}
          />
        </RadioGroup>
      </FormControl>
    </div>
  );
};

const YesNoTextOnly = ({ text }) => {
  return (
    <div
      style={{
        fontFamily: "GibsonRegular",
        color: theme.COLORS.primary_navyblue,
        letterSpacing: 1,
        fontSize: "1.6vmin",
      }}
    >
      {text}
    </div>
  );
};

export default BugReportYesNo;
